import { render } from "./PediatricClinicPage.vue?vue&type=template&id=9c55d39a"
import script from "./PediatricClinicPage.vue?vue&type=script&lang=js"
export * from "./PediatricClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__